import { AppState } from 'lib/types/global';

import { DataFiltersState } from './reducer';

export const getState = (state: AppState): DataFiltersState =>
  state.dataFilters;

export const getBranchId = (state: AppState) => getState(state).branchId;
export const getOrgId = (state: AppState) => getState(state).orgId;
export const getOfferDrnId = (state: AppState) => getState(state).offerDrnId;
export const getStartDate = (state: AppState) => getState(state).startDate;
export const getEndDate = (state: AppState) => getState(state).endDate;
export const getDateRangePreset = (state: AppState) =>
  getState(state).dateRangePreset;
